var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#575757"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dine In Mid Fid UI"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_264_141)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -31,
    y: -792,
    width: 390,
    height: 844,
    rx: 20,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000004055"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000004069"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000004054"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000004086",
    filter: "url(#filter0_d_264_141)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 390,
    height: 70,
    transform: "translate(-31 -17)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 48096366"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 130,
    height: 54,
    transform: "translate(-31 -17)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000004006"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1218"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 1177",
    d: "M12.8262 1V19",
    stroke: "#04ADAA",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 1178",
    d: "M12.8262 1C13.907 1 15.174 6.47278 15.174 12.7391H12.8262",
    stroke: "#04ADAA",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 1179",
    d: "M4 1V4.91304C4 6.20983 5.05104 7.26087 6.34783 7.26087C7.64383 7.26087 8.69565 6.20983 8.69565 4.91304V1",
    stroke: "#04ADAA",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 1180",
    d: "M6.34766 1V19",
    stroke: "#04ADAA",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_264_141",
    x: -62,
    y: -45,
    width: 444,
    height: 124,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_264_141"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_264_141",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_264_141"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -31,
    y: -792,
    width: 390,
    height: 844,
    rx: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuFilled);
export default __webpack_public_path__ + "static/media/menu-filled.f614fb4381e623c6756738c91d6adfd3.svg";
export { ForwardRef as ReactComponent };